interface GenerateButtonProps {
  onClick: () => void;
  disabled: boolean;
  isGenerating: boolean;
  points: number;
  cost: number | undefined;
}

export default function GenerateButton({ onClick, disabled, isGenerating, points, cost }: GenerateButtonProps) {
  const isActive = !disabled && !isGenerating;
  const { t } = useTranslation();
  const [animKey, setAnimKey] = useState(0);

  useEffect(() => {
    setAnimKey((k) => k + 1);
  }, [cost]);

  return (
    <div className="relative">
      {isActive && (
        <div className="absolute inset-0 rounded-2xl blur-md opacity-40"
          style={{ background: 'linear-gradient(135deg, #FF6B9D, #A855F7)', transform: 'translateY(4px) scaleX(0.98)' }} />
      )}
      <button
        data-testid="generate-btn"
        onClick={onClick}
        disabled={disabled || isGenerating}
        className={`relative w-full py-4 rounded-2xl text-white font-bold text-base flex items-center justify-center gap-2.5 transition-all cursor-pointer whitespace-nowrap ${
          isActive ? 'active:scale-[0.98]' : 'cursor-not-allowed'
        }`}
        style={
          isActive
            ? { background: 'linear-gradient(135deg, #FF6B9D 0%, #C084FC 50%, #A855F7 100%)' }
            : { background: 'linear-gradient(135deg, #D1D5DB, #9CA3AF)' }
        }
      >
        {isGenerating ? (
          <>
            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            <span>{t('gen_generating')}</span>
          </>
        ) : (
          <>
            <span className="text-lg font-bold tracking-wide">{t('gen_generate')}</span>
            {cost !== undefined && (
              <div
                key={animKey}
                className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-white/25 text-sm font-medium animate-bounce-in"
              >
                <i className="ri-flashlight-fill text-amber-300 text-xs"></i>
                <span>{cost}</span>
              </div>
            )}
          </>
        )}
      </button>
    </div>
  );
}
